(() => {
  if (window.hkFdagLoaded) return;
  window.hkFdagLoaded = true;
  const timers = new WeakMap();
  function initTimers() {
    document.querySelectorAll('[data-hk-countdown]').forEach((timer) => {
      if (timers.has(timer)) return;
      const deadline = Date.parse(timer.dataset.end);
      const tick = () => {
        const left = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        const values = { days: Math.floor(left / 86400), hours: Math.floor(left % 86400 / 3600), minutes: Math.floor(left % 3600 / 60), seconds: left % 60 };
        Object.entries(values).forEach(([key, value]) => {
          timer.querySelector(`[data-time="${key}"]`).textContent = String(value).padStart(2, '0');
        });
        if (left === 0) {
          timer.querySelector('.hk-fdag-clocklabel').textContent = timer.dataset.ended;
          timer.querySelector('[role="timer"]').setAttribute('aria-label', timer.dataset.ended);
          clearInterval(timers.get(timer));
        }
      };
      timers.set(timer, setInterval(tick, 1000));
      tick();
    });
  }
  function headerOffset() {
    const header = document.querySelector('.shopify-section-group-header-group:has(header)') || document.querySelector('header');
    if (header) document.documentElement.style.setProperty('--hk-fdag-header-height', `${header.getBoundingClientRect().height}px`);
  }
  // Bevar alternativ visning, også når temaets formular bygger en ny URL.
  function preserveView() {
    document.querySelectorAll('form[is="facet-form"]').forEach((form) => {
      if (form.querySelector('input[name="view"]')) return;
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'view'; input.value = 'foedselsdag';
      form.appendChild(input);
    });
    document.querySelectorAll('a[is="facet-remove"]').forEach((link) => {
      const url = new URL(link.href);
      url.searchParams.set('view', 'foedselsdag');
      link.href = url.toString();
    });
  }
  let refreshController;
  function refreshChips() {
    preserveView();
    const root = document.querySelector('[data-hk-chips-section]');
    if (!root || !root.querySelector('[data-hk-chip]')) return;
    if (refreshController) refreshController.abort();
    refreshController = new AbortController();
    const url = new URL(location.href);
    url.searchParams.set('section_id', root.dataset.hkChipsSection);
    fetch(url, { signal: refreshController.signal }).then((response) => {
      if (!response.ok) throw new Error('Kategorifiltre kunne ikke opdateres');
      return response.text();
    }).then((html) => {
      const updated = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hk-chips-section]');
      if (updated) root.replaceWith(updated);
    }).catch((error) => {
      if (error.name !== 'AbortError') location.assign(location.href.split('#')[0] + '#alle-tilbud');
    });
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-hk-chip]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const form = document.querySelector('form[is="facet-form"]');
    if (!form || typeof form.renderSection !== 'function') return;
    // Brug den aktuelle URL til at bevare alle øvrige filtre og sortering.
    const url = new URL(location.href);
    const target = new URL(link.href);
    url.searchParams.delete('filter.p.product_type');
    target.searchParams.getAll('filter.p.product_type').forEach((value) => url.searchParams.append('filter.p.product_type', value));
    url.searchParams.delete('page');
    url.searchParams.set('view', 'foedselsdag');
    if (new URL(location.href).searchParams.get('view') === 'foedselsdag-b') {
      event.preventDefault();
      url.hash = 'alle-tilbud';
      location.assign(url.toString());
      return;
    }
    url.searchParams.set('section_id', form.dataset.sectionId);
    url.hash = 'alle-tilbud';
    event.preventDefault();
    chipScroll = true;
    form.renderSection(url.toString(), event);
  });
  // Efter chipklik: læg overskriften lige under headeren (temaet scroller selv til gitteret, så vi venter på det).
  let chipScroll = false;
  function scrollToHeading() {
    const heading = document.getElementById('alle-tilbud');
    if (!heading) return;
    headerOffset();
    const header = document.querySelector('.shopify-section-group-header-group:has(header)') || document.querySelector('header');
    const offset = (header ? header.getBoundingClientRect().height : 100) + 24;
    window.scrollTo({ top: heading.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
  }
  document.addEventListener('collection:rerendered', () => {
    if (!chipScroll) return;
    chipScroll = false;
    setTimeout(scrollToHeading, 350);
  });
  document.addEventListener('collection:rerendered', refreshChips);
  document.addEventListener('shopify:section:load', () => { initTimers(); headerOffset(); preserveView(); });
  window.addEventListener('resize', headerOffset);
  initTimers(); headerOffset(); preserveView();
})();
